export default "__VITE_ASSET__HidESH_A__"